import React, {Fragment, useState} from "react";
import {Card, CardBody, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import IconBtn from "../../../../../CommonElements/IconButton";
import {Btn, ToolTip} from "../../../../../AbstractElements";
import BoardNumberParticipantForm from "../../BoardNumerParticipant/Component/Form";
import {FaCheckCircle} from "react-icons/fa";
import type {BoardNumberShowProps} from "../../Types/BoardTypes";

const BoardNumberShow: React.FC<BoardNumberShowProps> = ({callBack, boardNumber, isLocked = true}) => {
    const [boardNumberParticipantModalVisibility, setBoardNumberParticipantModalVisibility] = useState<boolean>(false);
    const [bookingDetailsTooltip, setBookingDetailsTooltip] = useState<boolean>(false);
    const toggle = () => setBookingDetailsTooltip(!bookingDetailsTooltip);

    const boardNumberParticipantModalToggle = () => {
        setBoardNumberParticipantModalVisibility(!boardNumberParticipantModalVisibility);
    }

    const winningNumber = boardNumber?.winning_number;
    const isWinningNumber = !!winningNumber


    return (
        <Fragment>
            <Card className={'text-center'}>
                <CardBody>
                    {/* Show range when end_number differs from number */}
                    <h2 style={{whiteSpace: 'nowrap'}}>
                        {boardNumber?.end_number !== undefined && boardNumber.end_number !== boardNumber.number
                            ? `${boardNumber.number.toString().padStart(2, '0')}-${boardNumber.end_number.toString().padStart(2, '0')}`
                            : boardNumber.number.toString().padStart(2, '0')}
                    </h2>
                    <div className='text-center '>
                        {isWinningNumber && <span className='badge badge-light-success mb-2'>Winning</span>}
                        {boardNumber?.participant ? <Fragment>
                                <FaCheckCircle style={{cursor: "pointer", color: '#54BA4AFF'}}
                                               id={'booking-details-tooltip-id'}/>
                                <ToolTip
                                    attrToolTip={{
                                        placement: 'top',
                                        isOpen: bookingDetailsTooltip,
                                        target: 'booking-details-tooltip-id',
                                        toggle: toggle
                                    }}>
                                    {`Booked By ${boardNumber?.participant?.name}`}
                                </ToolTip>
                            </Fragment> :
                            (isLocked ? <span className='text-muted'>Locked</span> :
                                <IconBtn type={'edit'} attrBtn={{onClick: () => boardNumberParticipantModalToggle()}}
                                         permission={'create-board-number-participant'}/>)
                        }

                    </div>
                </CardBody>
            </Card>
            {!isLocked && (
                <Modal isOpen={boardNumberParticipantModalVisibility} toggle={boardNumberParticipantModalToggle}
                       centered>
                    <ModalHeader>Add Participant</ModalHeader>
                    <ModalBody>
                        <BoardNumberParticipantForm
                            callBack={() => {
                                setBoardNumberParticipantModalVisibility(!boardNumberParticipantModalVisibility);
                                callBack?.();
                            }}
                            boardID={boardNumber.board_id}
                            boardNumberID={boardNumber.id}
                        />
                    </ModalBody>
                    <ModalFooter>
                        <Btn attrBtn={{color: 'primary', onClick: boardNumberParticipantModalToggle}}>Close</Btn>
                    </ModalFooter>
                </Modal>
            )}
        </Fragment>
    );
};

export default BoardNumberShow;
